import { MARQUEE_ITEMS } from "@/config/site";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="deals-marquee"
      className="relative bg-[#E60000] text-white overflow-hidden border-y border-black/20 py-3"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-display uppercase text-lg tracking-wide">
            <span className="px-6">{item}</span>
            <span className="text-black/60">x</span>
          </span>
        ))}
      </div>
    </div>
  );
}
